module.exports = __webpack_public_path__ + "static/media/25.df433e91.png";